import { combineReducers } from "redux";
import { getStatusReducer, getErrorReducer } from "../utils/reducer-generators";
import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils/get-action-types";
import { FETCH_OFFICE_PRACTICES } from "../constants/practices";
import { ERROR, LOADING, OK } from "../constants";
import { Action, PracticesState } from "../models/practices";

function data(state: PracticesState = {}, action: Action): PracticesState {
  const officeId = action.data && action.data.officeId ? action.data.officeId : 0;
  switch (action.type) {
    case getRequestActionType(FETCH_OFFICE_PRACTICES):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          status: LOADING,
          error: {},
        },
      };
    case getSuccessActionType(FETCH_OFFICE_PRACTICES):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          status: OK,
          error: {},
          data: action.payload,
        },
      };
    case getFailureActionType(FETCH_OFFICE_PRACTICES):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          status: ERROR,
          error: action.payload,
        },
      };
    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_OFFICE_PRACTICES]),
  error: getErrorReducer([FETCH_OFFICE_PRACTICES]),
  data,
});
